import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroll-component'

import { 
  getCourseIndex, fetchCourseIndex, fetchCourseMore
} from '../../../store/client'

import Grid from '../../../shared/ui/Grid'
import Button from '../../../shared/ui/Button'
import Link from '../../../shared/ui/Link'

import CourseCard from './CourseCard'

import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'
import RightIcon from '@material-ui/icons/ChevronRight'

const styles = theme => ({
  root: {
  }
})

const CourseList = ({ theme, classes, view, categoryKey, itemSize, maxRowCount, query, params, 
  fetchMore, fetchCourses, fetchCourseMore, selfLocation, courses, ...props }) => {

    const [hasMore, setHasMore] = useState(view !== 'all' ? true : false)
    const [counter, setCounter] = useState(1)

    let totalCourse = courses.lastFetched ? courses.data.count : 0

    useEffect(() => {
        fetchCourses(params)
    }, [categoryKey])

    const getCourseDetailLink = (row) => {
        return `/course/${row.uid}`
    }

    let courseList = courses.lastFetched ? courses.data.records : []
    let filteredCourse = query !== '' ? courseList.filter(item => item.name.toLowerCase().indexOf(query) > -1) : courseList

    const fetchMoreData = () => {
      if (courseList.length >= totalCourse) {  
        setHasMore(false)
      } else {
        params = {
          size: 18,
          offset: counter*18
        }
        setCounter(counter+1)

        fetchCourses(params, true)
      }
    };
    
    return (
        <Box>
          { view === 'all' &&
            <Box mt={5} display='flex' alignItems='center'>
              <Box flexGrow={1} className={classes.sectionSubtitle}>
                Private Courses ({courses.lastFetched ? courses.data.count : 0})
              </Box>
              <Box ml={2}>
                <Button component={Link} 
                  to={`${selfLocation}courses`}
                  icon={RightIcon}
                  iconPosition='right'
                  >
                  View All
                </Button>
              </Box>
            </Box>
            } 
          <Box display='flex' alignItems='center'>
          </Box>
            <Box mt={3}>
              <InfiniteScroll
              dataLength={ courseList.length }
              next={fetchMoreData}
              hasMore={hasMore}
              // loader={<h4 style={{textAlign: 'center'}}>Please Wait...</h4>}
              style={{overflow:'inherit'}}
              >    
                  <Grid
                      size={itemSize} 
                      maxRowCount={maxRowCount}
                      items={filteredCourse}
                      renderItem={(item, index) => (
                      <CourseCard theme={theme} classes={classes}
                          item={item}
                          linkTo={getCourseDetailLink(item)}
                          target={'_self'}
                          />
                      )}
                  />
              </InfiniteScroll>
              { !courses.isFetching && courses.lastFetched && filteredCourse.length <= 0 &&
                  <Box mt={2} display='flex' justifyContent='center' className={classes.emptyText}>
                      No private courses found in this category
                  </Box>
              }
                
              { courses.isFetching &&
              <Box display='flex' justifyContent='center' style={{ padding: theme.spacing(2) }}>
                  <CircularProgress size='1.5rem' disableShrink={true} />        
              </Box>
              }
            </Box>
        </Box>
    )
}

function keyPathFromProps(props) {
    let path = "default"
    let size
    let offset
  
    if (props.location && props.location.search !== undefined)
      size = new URLSearchParams(props.location.search).get('size') || 18
    
    if (props.location && props.location.search !== undefined)
      offset = new URLSearchParams(props.location.search).get('offset') || 0
    
    let params = {
      size: size,
      offset: offset
    }
  
    return [ path, params ]
  }
  
  const mapStateToProps = (state, ownProps) => {
    let categoryKey = ownProps.match.params.categoryKey || ''
    let [path, params] = keyPathFromProps(ownProps)
    let query = new URLSearchParams(ownProps.location.search).get('q') || ''
  
    return {
      categoryKey: categoryKey,
      params: params,
      query: query,
      courses: getCourseIndex(state, categoryKey, params)
    }
  }
  
  const mapDispatchToProps = (dispatch, ownProps) => {
    let categoryKey = ownProps.match.params.categoryKey || ''
    let [path, params] = keyPathFromProps(ownProps)
  
    return {
      fetchCourses: (params, fetchMore) => {
        dispatch(fetchCourseIndex(categoryKey, params, true, fetchMore))
      },
      fetchCourseMore: (params, oldItems) => {
        dispatch(fetchCourseMore(categoryKey, params, oldItems, true))
      }
    }
  }

export default withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps
     )(CourseList)
  )
  
